var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-icon",class:[_vm.big ? 'big' : 'small', _vm.getClassName, _vm.active ? 'active': '']})
}
var staticRenderFns = []

export { render, staticRenderFns }